import { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Container, Stack, TextField, Typography } from '@mui/material';

import { listSkins, deleteSkin } from '../api/skins';
import SkinsTable from '../components/skins/SkinsTable';
import SkinDialog from '../components/skins/dialog/SkinDialog';

export default function SkinsPage() {
  const [qInput, setQInput] = useState('');
  const [q, setQ] = useState('');
  const [tag, setTag] = useState('');
  const [page, setPage] = useState(1);
  const limit = 60;

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ items: [], total: 0, totalPages: 1 });

  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const fetchList = useCallback(async () => {
    setLoading(true);
    try {
      const res = await listSkins({ q, tag, page, limit });
      setData(res);
    } finally {
      setLoading(false);
    }
  }, [q, tag, page]);

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  const onSearchEnter = () => {
    setPage(1);
    setQ(qInput.trim());
  };

  const onCreate = () => {
    setEditing(null);
    setOpen(true);
  };

  const onEdit = (row) => {
    setEditing(row);
    setOpen(true);
  };

  const onRemove = async (id) => {
    if (!window.confirm('Delete this skin?')) return;
    await deleteSkin(id);
    await fetchList();
  };

  const title = useMemo(() => `Skin Manager (${data.total || 0})`, [data.total]);

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Typography variant="h5">{title}</Typography>
        <Button variant="contained" onClick={onCreate}>
          New Skin
        </Button>
      </Stack>

      <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
        <TextField
          size="small"
          label="Search (press Enter)"
          value={qInput}
          onChange={(e) => setQInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onSearchEnter();
            }
          }}
          fullWidth
        />

        <TextField
          size="small"
          label="Tag (optional)"
          value={tag}
          onChange={(e) => {
            setPage(1);
            setTag(e.target.value);
          }}
          sx={{ width: 220 }}
        />
      </Stack>

      <SkinsTable
        items={data.items || []}
        loading={loading}
        onEdit={onEdit}
        onDelete={onRemove}
        page={page}
        totalPages={data.totalPages || 1}
        onChangePage={setPage}
      />

      <SkinDialog
        open={open}
        editing={editing}
        onClose={() => setOpen(false)}
        onSaved={async () => {
          setOpen(false);
          await fetchList();
        }}
      />
    </Container>
  );
}